import { defineMessages, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import AdvancedHotkey from './component';

export const messages = defineMessages({
  name: {
    description: 'printingHotkeys Print Packing Slip',
    defaultMessage: 'Print Packing Slip',
    id: '1fcqwJ',
  },
});

export const hotkey = ['p', 's'];
export const barcodeContent = '+2QDK7K587PQU=';

const PrintPackingSlipHotkey = ({ children = null, handler }) => {
  const intl = useIntl();
  const hotkeyMetadata = useMemo(
    () => ({
      displayHotkeyStrings: ['ps'],
      barcode: barcodeContent,
      hotkey,
      handler,
      name: intl.formatMessage(messages.name),
      legacyCategory: 'printing',
      doNotTrack: true,
    }),
    [intl, handler],
  );

  return <AdvancedHotkey hotkey={hotkeyMetadata}>{children}</AdvancedHotkey>;
};

PrintPackingSlipHotkey.propTypes = {
  children: PropTypes.node,
  handler: PropTypes.func.isRequired,
};

export default PrintPackingSlipHotkey;
